import { Col, Form, FormInstance, Row } from "antd";
import { StateContext } from "context/context";
import { BaseInput as Input, BaseSelect as Select } from "../inputs";
import styles from "./styles/user-options.module.scss";

interface Props {
    form?: FormInstance;
}

const UserOptions = ({ form }: Props) => {

    const { state } = StateContext();
    const { event } = state;

    return (
        <>
            {event &&
                <Col span={24}>
                    <Form
                        layout="vertical"
                        form={form}
                        style={{ isolation: "isolate" }}
                    >
                        {event.userOptions?.firstName &&
                            <Form.Item
                                className={styles.item}
                                label="First Name"
                                style={{ zIndex: 0, position: "relative" }}
                                name="firstName"
                                required={false}
                                rules={[
                                    {
                                        required: true,
                                        message: "First Name is required"
                                    }
                                ]}
                            >
                                <Input
                                    variant="outlined"
                                    size="large"
                                    type="email"
                                />
                            </Form.Item>
                        }
                        {event.userOptions?.lastName &&
                            <Form.Item
                                className={styles.item}
                                label="Last Name"
                                style={{ zIndex: -1, position: "relative" }}
                                name="lastName"
                                required={false}
                                rules={[
                                    {
                                        required: true,
                                        message: "Last Name is required"
                                    },

                                ]}
                            >
                                <Input
                                    variant="outlined"
                                    size="large"
                                    type="email"
                                />
                            </Form.Item>
                        }
                        {event.userOptions?.email &&
                            <Form.Item
                                className={styles.item}
                                label="Email"
                                style={{ zIndex: -2, position: "relative" }}
                                name="email"
                                required={false}
                                rules={[
                                    {
                                        required: true,
                                        pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                        message: "Incorrect Email Format or Email is Required"
                                    }
                                ]}
                            >
                                <Input
                                    variant="outlined"
                                    size="large"
                                    type="email"
                                />
                            </Form.Item>
                        }
                        {event.userOptions?.selections.filter(x => x.required).map((option, index) => (
                            <Col span={24} order={option.order || 0} key={index}>
                                <Form.Item
                                    className={styles.item}
                                    name={option.label || `selection${index}`}
                                    label={option.label}
                                    required={false}
                                    rules={[
                                        {
                                            required: true,
                                            message: "Selection is required"
                                        }
                                    ]}
                                >
                                    <Select
                                        size="large"
                                        style={{ width: "100%" }}
                                        showSearch={false}
                                        {...option.multiSelect &&
                                        { mode: "multiple", }}
                                        {...option.userInput && {
                                            mode: "tags",
                                            maxTagCount: 1,
                                        }}
                                        options={option.options?.map((label, index) => (
                                            {
                                                key: index,
                                                label: label,
                                                value: label
                                            }
                                        ))}
                                    />
                                </Form.Item>
                            </Col>
                        ))}
                    </Form>
                </Col>
            }
        </>
    );
};

export default UserOptions;